import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import appEn from "./en/common.json";
import appKO from "./ko/common.json";
import { LANGUAGE } from "@root/constants";

const storedLang =
  localStorage.getItem("appLanguage") || LANGUAGE.KOREAN.toLowerCase();

i18next
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: storedLang, // 
    fallbackLng: LANGUAGE.KOREAN.toLowerCase(), 
    debug: true,
    interpolation: {},
    resources: {
      en: { common: appEn },
      ko: { common: appKO },
    },
    react: { useSuspense: false },
  });

export default i18next;
